/* eslint-disable @typescript-eslint/no-explicit-any */
import Filters from '@mercadoni/sinister/dist/cjs/filtersFilters'
import FiltersApplied from '@mercadoni/sinister/dist/cjs/filtersFiltersApplied'
import FilterSortDesktop from '@mercadoni/sinister/dist/cjs/filtersFilterSortDesktop'
import Carousel from '@mercadoni/sinister/dist/cjs/shared/components/Carousel'

import Empty from './components/Empty'
import Products from './components/Products'

import SearchResult from '@/quicksilver/components/SearchResult'
import LoadingFilterProducts from '../../components/LoadingFilterProducts'
import Banners from './components/Banners'
import SearchLayoutStyled from './SearchStyles'

const SearchLayout = ({
  loading,
  hasProducts,
  isMobile,
  promoted = {},
  filtersIcons,
  clientConfig,
  goToPath,
  carousels,
  widgetInteractionLogic,
}: any) => {
  const notHasProducts = !hasProducts && !loading

  if (loading) {
    return <LoadingFilterProducts isMobile={isMobile} hasBreadcrumbs={false} />
  }

  if (notHasProducts) {
    return (
      <SearchLayoutStyled isMobile={isMobile} emptyProducts>
        <div>
          <Empty />
        </div>
      </SearchLayoutStyled>
    )
  }

  const placementBeacons = promoted?.isPromoted
    ? {
        'data-criteo-placement-onloadbeacon': promoted.onLoadBeacon,
        'data-criteo-placement-onviewbeacon': promoted.onViewBeacon,
      }
    : {}

  return (
    <SearchLayoutStyled isMobile={isMobile}>
      <div>
        <Filters
          className="search-filter"
          isMobile={isMobile}
          filtersIcons={filtersIcons}
          goToPath={goToPath}
          clientConfig={clientConfig}
          sortOptionsConfig={clientConfig?.sortOptions}
        />
      </div>
      <div>
        {carousels?.length > 0 ? (
          carousels.map((carousel: any) => (
            <Carousel
              key={carousel.id}
              interactions={widgetInteractionLogic}
              carousel={carousel}
            />
          ))
        ) : (
          <Banners className="search-banners" />
        )}
        {!isMobile && (
          <div className="filters-container">
            <div className="filterSort-content">
              <SearchResult />
              <FilterSortDesktop
                goToPath={goToPath}
                sortOptionsConfig={clientConfig?.sortOptions}
              />
            </div>
            <div className="filtersApplied-content">
              <FiltersApplied
                className="search-filter-applied"
                clientConfig={clientConfig}
                goToPath={goToPath}
              />
            </div>
          </div>
        )}
        <div className="products-container" {...placementBeacons}>
          <Products />
        </div>
      </div>
    </SearchLayoutStyled>
  )
}

export default SearchLayout
